import {API, getApiPath} from '@/lib/utils/api.utils';
import {isError} from '@epic-mw/error-types';

export interface AuthRes {
	isLoggedIn: boolean;
	clearedOffline: boolean;
	accountId: string;
}

export const auth = async (): Promise<AuthRes> => {
	try {
		const response = await API.get<AuthRes>(`${getApiPath()}/auth`, {
			headers: {
				'Content-Type': 'application/json',
				'Cache-Control': 'no-store, no-cache',
				Expires: '0'
			}
		});
		return response?.data;
	} catch (err) {
		console.error('auth() failed to load', isError(err) && err.message);
		throw err;
	}
};
